export const Notice = {
    "已读":"已读",
    "已参与":"已参与",
    "未读":"未读",
    "未参与":"未参与",
    "提醒未读成员查看":"提醒未读成员查看",
    "系统提示":"系统提示",
    "是否要给未读的学员进行提醒本提醒仅通过微信推送只有微信绑定的用户才能收到此提醒":"是否要给未读的学员进行提醒？本提醒仅通过微信推送，只有微信绑定的用户才能收到此提醒!",
    "提醒已经发送到学生的微信":"提醒已经发送到学生的微信",
    "评论内容不允许为空":"评论内容不允许为空！",
    "还没有评论，发表第一个评论吧":"还没有评论，发表第一个评论吧",
    "点击评论":"点击评论",
    "友善是交流的起点":"友善是交流的起点...",
    "删除评论成功":"删除评论成功！",
    "评论成功":"评论成功",
    "全部评论":"全部评论",
    "发布你的评论":"发布你的评论",
    "发布评论成功":"发布评论成功",
    "公告标题":"公告标题",
    "导入已有公告":"导入已有公告",
    "公告详情":"公告详情",
    "选人":"选人",

}